const FA_DIGITS = '۰۱۲۳۴۵۶۷۸۹';
const AR_DIGITS = '٠١٢٣٤٥٦٧٨٩';

export function normalizeDigits(value) {
  return String(value ?? '').replace(/[۰-۹٠-٩]/g, (ch) => {
    const fa = FA_DIGITS.indexOf(ch);
    if (fa >= 0) return String(fa);
    const ar = AR_DIGITS.indexOf(ch);
    if (ar >= 0) return String(ar);
    return ch;
  });
}

export function normalizePhone(value) {
  let digits = normalizeDigits(value).replace(/\D+/g, '');

  if (digits.startsWith('98') && digits.length === 12) {
    digits = `0${digits.slice(2)}`;
  }

  if (digits.startsWith('9') && digits.length === 10) {
    digits = `0${digits}`;
  }

  return digits;
}
